import axios from 'axios';
import API_CONFIG from '../config/apiConfig';
const API_BASE = API_CONFIG.BASE_URL;
const COMPLAINTS_URL = `${API_BASE}/complaints`;
const CATEGORIES_URL = `${API_BASE}/categories`;
//track complaint by ID
export async function trackComplaint(complaintId) {
  const response = await fetch(
    `${API_CONFIG.BASE_URL}/complaints/track/${complaintId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch complaint');
  }

  return response.json();
}

export async function fetchAllComplaints() {}

// Submit complaint in register page

/**
 * Submits a complaint with photo to the backend API.
 * @param {Object} complaintData - The complaint details (name, mobile, etc.)
 * @param {File} photoFile - The photo file to upload
 * @returns {Promise<Object>} - The API response
 */
export const submitComplaint = async (complaintData, photoFile) => {
  const formData = new FormData();
  // Wrap JSON string in double quotes for backend compatibility
  formData.append(
    'request',
    new Blob([JSON.stringify(complaintData)], { type: 'application/json' })
  );
  formData.append('request', `"${JSON.stringify(complaintData)}"`);
  if (photoFile) {
    formData.append('photos', photoFile);
  }
  try {
    const response = await axios.post(
      `${API_CONFIG.BASE_URL}/complaints`,
      formData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ...existing code...
